'use strict';

var env = process.env.NODE_ENV || 'development';
var config = require('./default')({});

var environments = {
  test: function test() {
    return require('./test')(config);
  },
  local: function local() {
    return require('./development')(config);
  },
  development: function development() {
    return require('./development')(config);
  },
  continuous: function continuous() {
    return require('./continuous')(config);
  },
  staging: function staging() {
    return require('./staging')(config);
  },
  preprod: function preprod() {
    return require('./preprod')(config);
  },
  production: function production() {
    return require('./production')(config);
  }
};

module.exports = environments[env]();


//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = 2236
// module chunks = 0